class flowAddCart extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  handleClick(event) {
    const button = this;
    const card = button.closest(".location-flow-check-card");
    const trigger = card?.querySelector(".flow-trigger-click");

    if (card && trigger) {
      trigger.click();

      const intervalId = window.setInterval(function () {
        button.textContent = trigger.textContent;
        if (trigger.textContent == "Add to cart") {
          clearInterval(intervalId);
        }
      }, 500);

      setTimeout(() => {
        clearInterval(intervalId);
      }, 12000);
    }
  }
}
customElements.define("flow-add-cart", flowAddCart);

class MyCustomElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // console.log(this);
    // console.log(window.matchedLocation);
    const $this = this;
    const productId = this.dataset.productId;
    const firstVariantId = this.dataset.firstVariantId;
    
    window.getVariantLocation($this, productId, firstVariantId);

    if (
      $this.closest(".location-flow-check-card") &&
      $this.closest(".location-flow-check-card").querySelector(".has-search")
    ) {
      $this
        .closest(".location-flow-check-card")
        .querySelector(".has-search")
        .classList.add("active");
    }
  }
}
// customElements.define('location-flow', MyCustomElement);

window.getVariantLocation = function ($this, product_id, variant_id) {
  const variantId = `${variant_id}`;

  if (!$this.querySelector(".location-flow-js")) return;
  let rawText = $this.querySelector(".location-flow-js").textContent.trim();
  let context = {};
  eval(`(function(window){ ${rawText} })(context);`);
  const productData = context[`product_${product_id}`].data;

  // const productData = window[`product_${product_id}`].data;
  const variantData = productData.find((item) =>
    item.hasOwnProperty(variantId)
  );

  if (variantData) {
    // console.log(variantData[variantId][window.matchedLocation]);
    const qty = parseInt(variantData[variantId][window.matchedLocation]);
    if (variantData[variantId]["check-inventory"] == "false") return;

    let checkCard;
    if($this.closest(".location-flow-check-card")){
      checkCard = $this.closest(".location-flow-check-card");
    }else if($this.closest(".t4s-product")){
      checkCard = $this.closest(".t4s-product");
    }

    if (checkCard) {
      if (qty <= 0) {
        /* sticky buttom text change pdp */
        if (document.querySelector("[data-sticky-addtocart]")) {
          document
            .querySelector("[data-sticky-addtocart] button.t4s-sticky-atc__atc")
            .classList.add("disabled");
        }
        /* end sticky buttom text change pdp */

        /* shopify payment button style - 01 */
        if(checkCard.querySelector(".shopify-payment-button")){
          checkCard.querySelector(".shopify-payment-button").classList.add('disabled');
        }
        /* end shopify payment button style - 01 */

        /* all atc-button */
        if(checkCard.querySelector('.atc__button')){
          checkCard.querySelectorAll('.atc__button').forEach(button => {
            button.classList.add('disabled');
          });
        }
        if(checkCard.querySelector('.flow-add-cart')){
          checkCard.querySelectorAll('.flow-add-cart').forEach(button => {
            button.classList.add('disabled');
          });
        }
        /* end all atc-button */
      } else {
        /* sticky buttom text change pdp */
        if (
          $this.closest(".t4s-product-form__variants") &&
          document.querySelector("[data-sticky-addtocart]")
        ) {
          document
            .querySelector("[data-sticky-addtocart] button.t4s-sticky-atc__atc")
            .classList.remove("disabled");
        }
        /* end sticky buttom text change pdp */

        /* shopify payment button style - 01 */
        if(checkCard.querySelector(".shopify-payment-button")){
          checkCard.querySelector(".shopify-payment-button").classList.remove('disabled');
        }
        /* end shopify payment button style - 01 */

        /* all atc-button and custom our class */
        if(checkCard.querySelector('.atc__button')){
          checkCard.querySelectorAll('.atc__button').forEach(button => {
            button.classList.remove('disabled');
          });
        }
        if(checkCard.querySelector('.flow-add-cart')){
          checkCard.querySelectorAll('.flow-add-cart').forEach(button => {
            button.classList.remove('disabled');
          });
        }
        /* end all atc-button and custom our class */
      }
    }
  }
};

